import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class LeftVessel extends Vue {

    @Prop()
    currentActiveImageIndex!: number;

    get titleClasses(): any
    {
        return {
            'main-content__title': true,
            'main-content__title--one': this.currentActiveImageIndex === 0,
            'main-content__title--two': this.currentActiveImageIndex === 1,
            'main-content__title--three': this.currentActiveImageIndex === 2,
            'main-content__title--four': this.currentActiveImageIndex === 3
        }
    }
    
    get stripeClasses(): any
    {
        return {
            'nav__stripe': true,
            'nav__stripe--one': this.currentActiveImageIndex === 0,
            'nav__stripe--two': this.currentActiveImageIndex === 1,
            'nav__stripe--three': this.currentActiveImageIndex === 2,
            'nav__stripe--four': this.currentActiveImageIndex === 3
        }
    }
}
